// extracted by mini-css-extract-plugin
export default {"wrapper":"Pay_wrapper__n3CPo","header":"Pay_header__SAD0s","goBack":"Pay_goBack__97MwO","container":"Pay_container__gFN0l"};